import React from "react";
import { map } from "lodash";

import { fontFamily } from "./styles";

const FormulaTable = ({ items }) => (
  <table
    style={{
      width: "100%",
      fontFamily,
      fontSize: "16px"
    }}
  >
    <tbody>
      <tr
        style={{
          color: "#2F9CA3",
          fontWeight: "800",
          fontSize: "18px",
          textAlign: "center"
        }}
      >
        {map(items, (item, key) => (
          <td key={key} style={item.highlighted ? {} : { color: "#000000" }}>
            {item.name}
          </td>
        ))}
      </tr>
      <tr style={{ height: "1em" }} />
      <tr style={{ textAlign: "center" }}>
        {map(items, (item, key) => (
          <td key={key}>{item.value}</td>
        ))}
      </tr>
    </tbody>
  </table>
);

export default FormulaTable;



// WEBPACK FOOTER //
// ./src/components/analysis/FormulaTable.js